<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>个人中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="1"></centerLeft>
				<div class="center-right">
					
					<div class="center-right-top flex-center flex-between">
						<div class="center-right-top-text">{{user.companyName?user.companyName:user.phone}}</div>
						<div class="center-right-top-right flex-end flex-center">
							<router-link to="/useraccount" class="a flex-center flex-midden"><img src="@/assets/images/me/user.png"/>信用账户</router-link>
							<router-link to="/userscore" class="a flex-center flex-midden"><img src="@/assets/images/me/vip.png"/>积分账户</router-link>
						</div>
					</div>
					
					<div class="center-right-title flex-between flex-center">
						<div class="center-right-title-text">我的订单</div>
						
						<router-link to="/userorder" class="center-right-title-right flex-end flex-center">
							<div>查看更多</div>
							<img src="@/assets/images/right.png"/>
						</router-link>
					</div>
					
					<div class="order-list" v-if="list.length > 0">
						<div class="order-item" v-for="(item, index) in list" :key="item.id">
							<div class="order-info flex-between flex-center">
								<div style="width: 100%;">
									<img class="order-info-image" v-for="(value,key) in item.goodsList" v-if="key < 4" :src="value.goodsSpecImage"></img>
								</div>
								<div class="order-info-status" v-if="item.orderStatus == -2">已关闭</div>
								<div class="order-info-status" v-if="item.orderStatus == -1">已取消</div>
								<div class="order-info-status" v-if="item.orderStatus == 0">待支付</div>
								<div class="order-info-status" v-if="item.orderStatus == 1">待接单</div>
								<div class="order-info-status" v-if="item.orderStatus == 2">待发货</div>
								<div class="order-info-status" v-if="item.orderStatus == 3">待签收</div>
								<div class="order-info-status" v-if="item.orderStatus == 4">已完成</div>
								<div class="order-info-price">
									<div>￥{{item.meetPrice}}</div>
									<div>（含运费：￥{{item.freightPrice}}元）</div>
									<div v-if="item.payType == 1">信用付</div>
									<div v-if="item.payType == 2">线下付款</div>
								</div>
								
								<div class="order-info-button">
									<div class="order-info-button-button" v-if="item.orderStatus == 0 && item.payType != 2" @click="toPay(item.id)">去支付</div>
									<div class="order-info-button-button" v-if="item.orderStatus == 0 && item.payType == 2 && item.paymentStatus === -1" @click="toPay(item.id)">去支付</div>
									<div class="order-info-button-button" v-if="item.orderStatus == 3" @click="changeStatusValue(item.id,index, 4)">确认收货</div>
									<div @click="toOrderInfo(item.id)">查看详情</div>
									<div v-if="item.orderStatus != 0" @click="addshop(item.id)">再次购买</div>
									<div v-if="item.orderStatus == 0" @click="changeStatusValue(item.id,index, -1)">取消订单</div>
									<div v-if="item.orderStatus > 0 && item.orderStatus < 4" @click="toRefund(item.id)">申请售后</div>
								</div>
								
							</div>
							
						</div>
					</div>
					
					<noData v-if="list.length == 0 && isLoad == true" msg="暂无订单"></noData>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import noData from '@/components/noData.vue'
import {getOrderList,updateOrderStatus,copyOrder} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft,
		noData
	},
	data(){
		return {
			list:[],
			isLoad:false
		}
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			getOrderList({condition:{},page:1,size:5}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		toScore(){
			this.$message.success("暂未开放");
		},
		
		toPay(id){
			this.$router.push("/pay?id="+(id*23+20));
		},
		toOrderInfo(id){
			this.$router.push("/orderinfo?id="+(id*23+20));
		},
		changeStatusValue(id,index, status){
			this.$alert('确定操作吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						updateOrderStatus({orderId:id,orderStatus:status}).then(res=>{
							if(res.code == 1000){
								this.getList();
								this.$message.success("操作完成");
							}else{
								return this.$message.error(res.message);
							}
						})
					}
				}
			});
		},
		addshop(id){
			copyOrder({id:id}).then(res=>{
				if(res.code == 1000){
					this.$router.push("/pay?id="+res.data);
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		toRefund(id){
			this.$router.push("/userrefund?id="+id);
		},
		toAcount(){
			
		}
	}
}
</script>

<style lang="scss" scoped>
	
	
		.order-item{
			border-bottom: 1px solid rgba(7, 11, 19, 0.1);
			box-sizing: border-box;
			.order-info{
				padding: 20px 0px 20px 40px;
				box-sizing: border-box;
				width: 100%;
				.order-info-image{
					width: 80px;
					height: 80px;
					border: 1px solid rgba(0, 0, 0, 0.1);
					flex: 0 0 82px;
					margin-right: 20px;
				}
				.order-info-name{
					font-size: 16px;
					color: #070B13;
					width: 100%;
					line-height: 40px;
					span{
						max-width: 300px;
						display: inline-block;
					}
				}
				.order-info-status{
					font-size: 16px;
					color: #070B13;
					flex: 0 0 100px;
					text-align: center;
				}
				.order-info-price{
					font-size: 14px;
					line-height: 22px;
					color: #070B13;
					text-align: center; 
					flex: 0 0 200px;
				}
				.order-info-button{
					border-left: 1px solid rgba(7, 11, 19, 0.1);
					width: 168px;
					text-align: center;
					flex: 0 0 168px;
					div{
						font-size: 12px;
						line-height: 16px;
						color: #070B13;
						margin-bottom: 8px;
						cursor: pointer;
		
					}
					.order-info-button-button{
						width: 88px;
						height: 28px;
						border: 1px solid rgba(233, 26, 18, 0.3);
						font-size: 14px;
						line-height: 28px;
						color: #E91A12;
						text-align: center;
						margin: 0 auto 8px;
					}
				}
			}
		}
	
	.center-right-title{
		margin: 20px 40px 0px;
		.center-right-title-text{
			font-size: 16px;
			font-weight: 500;
			line-height: 24px;
			color: #070B13;
		}
		.center-right-title-right{
			div{
				height: 24px;
				font-size: 14px;
				line-height: 24px;
				text-align: center;
				color: #070B13;
			}
			img{
				width: 16px;
				height: 16px;
				margin-left: 8px;
			}
		}
	}
	.center-right{
		padding-top: 40px;
		box-sizing: border-box;
		min-height: 920px;
		width: 100%;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
		.center-right-top{
			width: 960px;
			border-radius: 8px;
			background: #F8F8F8;
			padding: 40px;
			margin: 0 auto;
			box-sizing: border-box;
			.center-right-top-text{
				font-size: 18px;
				color: #070B13;
			}
			.center-right-top-right{
				.a{
					width: 160px;
					height: 28px;
					border-radius: 40px;
					background: #FFF2F1;
					border: 1px solid #E91A12;
					font-size: 14px;
					line-height: 28px;
					color: #070B13;
					margin-left: 30px;
					cursor: pointer;
					img{
						width: 16px;
						height: 16px;
						margin-right: 8px;
					}
				}
			}
		}
	}
	@import url("../assets/user.scss");
</style>
